// تعمیرات خودرو
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import { openReport } from '../../components/report';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, qs, toFa, fmtAmt, Grid, Field, TextIn, DateIn, Lookup, SuggestIn, Modal, DeleteDialog, MsgDialog, excelCols, smallBtn,
} from './carsShared';
import CarRepairPieces from './CarRepairPieces';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNNEWREQUEST', 'BTNCARREPAIRPIECES',
  'BTNREPAIRREQUEST', 'BTNREPAIRCONFIRM', 'BTNREPAIRHISTORY', 'BTNFUELHAVALEH'];
const num = v => Number(String(v ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/,/g, '')) || 0;

const blank = (keep = {}) => ({
  kilometer: '', event_date: '', amount: '', added_tax: '', remark: '', reason: '', paid_before: false,
  request_no: '', request_date: '', confirm_no: '', confirm_date: '', letter_no: '', letter_date: '', factor_no: '', factor_date: '',
  receiver: { id: 0, title: '' }, asker: { id: 0, title: '' }, department: { id: 0, title: '' }, kind: { id: 0, title: '' }, ...keep,
});

function rowToForm(r) {
  return blank({
    kilometer: r['کیلومتر'] ?? '', event_date: r['تاریخ'] || '', amount: r['مبلغ'] ?? '', added_tax: r['مالیات بر ارزش افزوده'] ?? '',
    remark: r['شرح تعمیرات'] || '', reason: r['شرح ایراد'] || '', paid_before: !!r.PaidBefore,
    request_no: r['شماره درخواست'] ?? '', request_date: r['تاریخ درخواست'] || '',
    confirm_no: r['شماره تایید'] ?? '', confirm_date: r['تاریخ تایید'] || '',
    letter_no: r['شماره نامه معرفی'] || '', letter_date: r['تاریخ نامه معرفی'] || '',
    factor_no: r['شماره فاکتور'] || '', factor_date: r['تاریخ فاکتور'] || '',
    receiver: { id: r.AmountReceiverId || 0, title: r['تعمیرگاه'] || '' },
    asker: { id: r.AskerId || 0, title: r['درخواست کننده'] || '' },
    department: { id: r.DepartmentId || 0, title: r['واحد اجرایی'] || '' },
    kind: { id: r.CarRepairKindId || 0, title: r['نوع تعمیرات'] || '' },
  });
}

function RepairForm({ form, F, piecesTotal }) {
  return (
    <>
      <div style={ui.row}>
        <label style={{ fontSize: '12px', alignSelf: 'center' }}>
          <input type="checkbox" checked={form.paid_before} onChange={e => F('paid_before', e.target.checked)} /> بدون پرداخت وجه
        </label>
        {form.paid_before && <>
          <Field label="نامه معرفی: شماره"><TextIn num value={form.letter_no} disabled onChange={() => {}} /></Field>
          <Field label="تاریخ"><TextIn num value={form.letter_date} disabled onChange={() => {}} /></Field>
        </>}
        <Field label="فاکتور"><TextIn num value={form.factor_no} onChange={v => F('factor_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.factor_date} onChange={v => F('factor_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="تاریخ"><DateIn value={form.event_date} onChange={v => F('event_date', v)} /></Field>
        <Field label="کیلومتر"><TextIn num value={form.kilometer} onChange={v => F('kilometer', v)} /></Field>
        <Field label="مبلغ"><TextIn num value={form.amount} onChange={v => F('amount', v)} /></Field>
        <Field label="مالیات بر ارزش افزوده">
          <TextIn num value={form.added_tax} onChange={v => F('added_tax', v)} title="F11: محاسبه با درصد"
            onKeyDown={e => { if (e.key === 'F11') { e.preventDefault(); F('added_tax', num(form.amount) * num(form.added_tax) / 100); } }} />
        </Field>
      </div>
      <div style={ui.row}>
        <Field label="هزینه قطعات"><TextIn num value={fmtAmt(piecesTotal)} disabled onChange={() => {}} /></Field>
        <Field label="اجرت تعمیران"><TextIn num value={fmtAmt(num(form.amount) - piecesTotal)} disabled onChange={() => {}} /></Field>
        <Field label="تعمیرگاه/فروشگاه"><Lookup path="/repair/lookup/receiver/" value={form.receiver} onChange={v => F('receiver', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="درخواست: شماره"><TextIn num value={form.request_no} onChange={v => F('request_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.request_date} onChange={v => F('request_date', v)} /></Field>
        <Field label="تایید: شماره"><TextIn num value={form.confirm_no} onChange={v => F('confirm_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.confirm_date} onChange={v => F('confirm_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="درخواست کننده"><Lookup path="/repair/lookup/people/" value={form.asker} onChange={v => F('asker', v)} /></Field>
        <Field label="واحد اجرایی"><Lookup path="/repair/lookup/department/" value={form.department} onChange={v => F('department', v)} /></Field>
        <Field label="نوع تعمیرات"><Lookup path="/repair/lookup/repairkind/" value={form.kind} onChange={v => F('kind', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="شرح ایراد"><SuggestIn path="/repair/remarks/?field=reason" value={form.reason} onChange={v => F('reason', v)} /></Field>
        <Field label="شرح تعمیرات/قطعات"><SuggestIn path="/repair/remarks/?field=remark" value={form.remark} onChange={v => F('remark', v)} /></Field>
      </div>
    </>
  );
}

export default function CarRepair({ user, onBack, carId, carTitle = '', year }) {
  const fb = useFormButtons('FRMCARREPAIR', BUTTONS);
  const [cols, setCols] = useState([]);
  const [meta, setMeta] = useState({});
  const [sel, setSel] = useState(null);
  const [detail, setDetail] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [newReq, setNewReq] = useState(false);
  const [range, setRange] = useState({ from: '', to: '' });
  const [askConfirm, setAskConfirm] = useState(false);
  const [pieces, setPieces] = useState(false);
  const [saving, setSaving] = useState(false);

  const L = usePagedList((page) => API(`/repair/?${qs({ page, car_id: carId })}`)
    .then(j => {
      if (j.ok && page === 1) {
        setCols(j.columns || []); setMeta(j);
        setRange(r => (r.from ? r : { from: j.from_date, to: j.to_date }));
      }
      return j;
    }));
  const reload = () => L.reload({});
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  const loadDetail = (r) => {
    setDetail(null);
    if (!r) return;
    API(`/repair/${r.CarRepairId}/detail/?${qs({ request_no: r['شماره درخواست'], request_date: r['تاریخ درخواست'] })}`)
      .then(j => { if (j.ok) setDetail(j); });
  };
  useEffect(() => { loadDetail(sel); }, [sel]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew = async () => {
    const j = await API(`/repair/prepare/?${qs({ car_id: carId, mode: 'new', year })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(blank({ receiver: meta.last_receiver || { id: 0, title: '' },
      request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date }));
    if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    setErr(''); setNewReq(true); setModal('new');
  };
  const openEdit = async () => {
    const j = await API(`/repair/prepare/?${qs({ car_id: carId, id: sel.CarRepairId, mode: 'edit' })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(rowToForm(sel)); setErr(''); setNewReq(false); setModal('edit');
  };
  const newRequest = async () => {
    const j = await API(`/repair/new-request/?${qs({ request_date: form.request_date, confirm_date: form.confirm_date, year })}`);
    if (j.ok) {
      setForm(f => ({ ...f, request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date }));
      if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    }
  };
  const save = async () => {
    setSaving(true); setErr('');
    const body = JSON.stringify({ ...form, car_id: carId, receiver_id: form.receiver.id, asker_id: form.asker.id,
      department_id: form.department.id, repair_kind_id: form.kind.id });
    const y = year ? `?year=${year}` : '';
    const j = modal === 'new'
      ? await API(`/repair/create/${y}`, { method: 'POST', body })
      : await API(`/repair/${sel.CarRepairId}/update/${y}`, { method: 'PUT', body });
    setSaving(false);
    if (!j.ok) { setErr(j.msg); if (j.new_request) setNewReq(true); return; }
    if (j.info) setMsg(j.info);
    setModal(null); reload();
  };
  const doDelete = async () => {
    setModal(null);
    const j = await API(`/repair/${sel.CarRepairId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };
  const report = async (key, params) => { try { await openReport(key, params); } catch (e) { setMsg(e.message); } };
  const has = !!sel;
  const havaleh = sel && sel.PaidBefore && !Number(sel['شماره فاکتور'] || 0) && fb.can('BTNNEW') && fb.can('BTNFUELHAVALEH');

  if (pieces && sel) {
    return <CarRepairPieces user={user} repairId={sel.CarRepairId} title={`${meta.car_title || carTitle} — ${toFa(sel['تاریخ'])}`}
      onBack={() => { setPieces(false); reload(); loadDetail(sel); }} />;
  }

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={openEdit} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
        {fb.can('BTNCARREPAIRPIECES') && <button disabled={!has} onClick={() => setPieces(true)} style={{ ...ui.btnItems, opacity: has ? 1 : 0.4 }}>قطعات مصرفی</button>}
        {havaleh && <button onClick={() => report('tadarokat.car_repair_havaleh', { id: sel.CarRepairId })} style={smallBtn('#00695c')}>حواله تعمیرات</button>}
      </div>
      {fb.can('BTNREPAIRREQUEST') && <button disabled={!has} onClick={() => report('tadarokat.car_repair_request', { request_no: sel['شماره درخواست'], request_date: sel['تاریخ درخواست'] })} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>برگه درخواست</button>}
      {fb.can('BTNREPAIRCONFIRM') && <button disabled={!has} onClick={() => setAskConfirm(true)} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>تاییدیه</button>}
      {fb.can('BTNREPAIRHISTORY') && <>
        <Field label="از" width="130px"><DateIn value={range.from} onChange={v => setRange(r => ({ ...r, from: v }))} /></Field>
        <Field label="تا" width="130px"><DateIn value={range.to} onChange={v => setRange(r => ({ ...r, to: v }))} /></Field>
        <button onClick={() => report('tadarokat.car_repair_history', { car_id: carId, from: range.from, to: range.to })} style={smallBtn()}>سابقه تعمیرات</button>
      </>}
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="ردیف" />
      <ExcelButton title="تعمیرات خودروها" subtitle={meta.car_title || carTitle} columns={excelCols(cols, L.data)} rows={L.data} />
    </>
  ) : null;

  const confirmParams = (c) => ({ confirm_no: sel['شماره تایید'], confirm_date: sel['تاریخ تایید'], request_date: sel['تاریخ درخواست'], is_confirm: c });

  return (
    <>
      <ListPage user={user} onBack={onBack} title={`تعمیرات خودرو ${meta.car_title || carTitle}`} subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="ردیف">
        <div style={ui.splitWrap}>
          <div style={{ ...ui.topPane, display: 'flex', gap: '8px' }}>
            <div style={{ flex: 3, overflow: 'auto' }}>
              <Grid columns={cols} rows={L.data} rowKey="CarRepairId" selectedKey={sel?.CarRepairId} onSelect={setSel} moneyCols={['مبلغ', 'مالیات بر ارزش افزوده']} />
            </div>
            {detail && detail.pieces.length > 0 && (
              <div style={{ flex: 1, overflow: 'auto' }}>
                <Grid columns={detail.pieces_columns} rows={detail.pieces} rowKey="CarRepairPiecesId" moneyCols={['فی', 'جمع']} />
              </div>
            )}
          </div>
          {detail && detail.request.length > 0 && (
            <div style={ui.bottomPane}>
              <div style={{ padding: '6px 10px', fontWeight: 700, fontSize: '12px', color: '#1a2f50' }}>
                ریز درخواست شماره {toFa(sel?.['شماره درخواست'])} تاریخ {toFa(sel?.['تاریخ درخواست'])}
              </div>
              <Grid columns={detail.request_columns} rows={detail.request} rowKey="CarRepairId" moneyCols={['مبلغ', 'مالیات بر ارزش افزوده']} />
            </div>
          )}
        </div>
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ تعمیرات جدید' : '✎ ویرایش تعمیرات'} onClose={() => setModal(null)} width="900px"
          footer={<>
            {newReq && fb.can('BTNOK') && <button onClick={newRequest} style={smallBtn('#6a1b9a')}>شماره درخواست جدید</button>}
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') &&
              <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : 'ثبت'}</button>}
          </>}>
          {err && <div style={{ ...ui.errBox, whiteSpace: 'pre-line' }}>⚠️ {err}</div>}
          <RepairForm form={form} F={F} piecesTotal={modal === 'edit' && detail ? detail.total_price : 0} />
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {askConfirm && (
        <WarningDialog title="انتخاب کنید" lines={[]} confirmLabel="تاییدیه" cancelLabel="صورتجلسه مصرف"
          onConfirm={() => { setAskConfirm(false); report('tadarokat.car_repair_confirm', confirmParams(1)); }}
          onCancel={() => { setAskConfirm(false); report('tadarokat.car_repair_confirm', confirmParams(0)); }} />
      )}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
